<template>
  <section id="reviews" :aria-label="$t.reviewSnapshot">
    <base-lazy-load>
      <div class="dark c-white px-12 py-8 text-center bg-black lg:space-y-6">
        <h2 class="elevate-title-3">
          {{ $t.reviewSnapshot }}
        </h2>
        <div
          v-if="ratio > recommendationRateThreshold"
          class="divide-grey-30 lg:flex lg:center lg:divide-x <lg:divide-y"
        >
          <div class="<lg:py-6 lg:px-14">
            <p v-if="rollup.averageRating" class="fw-black">
              <span class="text-10xl">{{ rollup.averageRating }}</span>
              <span class="text-5xl">/5</span>
            </p>
            <vf-rating v-if="rollup.averageRating" class="mx-a" :value="rollup.averageRating" />
          </div>
          <div class="<lg:py-6 lg:px-14">
            <p class="fw-black">
              <span class="text-10xl">{{ ratio }}</span>
              <span class="text-5xl">%</span>
            </p>
            <p class="elevate-body-4">
              {{ $t.customerRecommended }}
            </p>
          </div>
        </div>
        <vf-button size="xs" variant="secondary" @click="openReviews">
          {{ replaceAll($pluralize($t.numberOfReviews, reviewsCount), { reviewsCount }) }}
        </vf-button>
        <dialog-reviews size="full" />
      </div>
    </base-lazy-load>
  </section>
</template>

<script setup lang="ts">
import type { ProductReviewsRollup } from '#root/api/clients/product/data-contracts'

const { $gtm } = useNuxtApp()
const { recommendationRateThreshold, dialogOptions } = useAppConfig().pages.pdp.reviews
const { reviewsData } = usePdp()

const rollup = computed(() => reviewsData.value?.rollup || {} as ProductReviewsRollup)
const ratio = computed(() => Math.round((rollup.value.recommendedRatio || 0) * 100))
const reviewsCount = computed(() => rollup.value.reviewCount || 0)

const DialogReviews = createDialog('reviews', dialogOptions.reviews)

const openReviews = () => {
  $gtm.push('pdpPage.onViewReviews')
  DialogReviews.open()
}
</script>
